module.exports = __webpack_public_path__ + "img/generator-default.62c1292f.gif";